<template>
  <div class="custom">
    <div class="custom-tool">
      <p class="custom-tool-title">云店预览</p>
      <div class="ct-box">
        <div class="ctb-item" v-for="(component, index) in Modal" :key="'components-' + index">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{component.config}}</div> -->
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{component.componentName}}</div> -->

          <component :is="component.componentName" :ref="component.componentName + index" :info="component" :index="index" @closeModel="closeModel(index, $event)" v-model="component.config"></component>
        </div>
        <div class="u-empty" v-if="false">暂无数据</div>
      </div>
    </div>
    <div class="custom-tool2">
      <div class="ctb-item2" v-for="(component, index) in Modal" :key="'components-' + index">
        <!-- <div v-if="component.componentName === 'customCompanyObjective'">
            <div style="word-break: break-all; white-space: pre-wrap;">{{component.config}}</div>
        </div>-->
        <component :is="component.componentName + '2'" :ref="component.componentName + '2-' + index" :info="component" :index="index" @closeModel="closeModel(index, $event)" v-model="component.config"></component>
      </div>
      <div class="u-empty" v-if="false">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import customCompanyRelease from "@components/custom-company-component-new/common/custom-company-release/custom-company-release.vue";
import customCompanyCooperation from "@components/custom-company-component-new/common/custom-company-cooperation/custom-company-cooperation.vue";
import customCompanyBrand from "@components/custom-company-component-new/common/custom-company-brand/custom-company-brand.vue";
import customCompanyExample from "@components/custom-company-component-new/common/custom-company-example/custom-company-example.vue";
import customCompanyProductGroup from "@components/custom-company-component-new/common/custom-company-productGroup/custom-company-productGroup.vue";
import customCompanyBanner from "@components/custom-company-component-new/common/custom-company-banner/custom-company-banner.vue";
import customCompanyHeader from "@components/custom-company-component-new/common/custom-company-header/custom-company-header.vue";
import customCompanyObjective from "@components/custom-company-component-new/common/custom-company-objective/custom-company-objective.vue";
import customCompanyExhibition from "@components/custom-company-component-new/common/custom-company-exhibition/custom-company-exhibition.vue";
import customCompanyActivity from "@components/custom-company-component-new/common/custom-company-activity/custom-company-activity.vue";

import customCompanyCooperation2 from "@components/custom-company-component-new/common2/custom-company-cooperation/custom-company-cooperation.vue";
import customCompanyBrand2 from "@components/custom-company-component-new/common2/custom-company-brand/custom-company-brand.vue";
import customCompanyExample2 from "@components/custom-company-component-new/common2/custom-company-example/custom-company-example.vue";
import customCompanyProductGroup2 from "@components/custom-company-component-new/common2/custom-company-productGroup/custom-company-productGroup.vue";
import customCompanyBanner2 from "@components/custom-company-component-new/common2/custom-company-banner/custom-company-banner.vue";
import customCompanyHeader2 from "@components/custom-company-component-new/common2/custom-company-header/custom-company-header.vue";
import customCompanyObjective2 from "@components/custom-company-component-new/common2/custom-company-objective/custom-company-objective.vue";
import customCompanyExhibition2 from "@components/custom-company-component-new/common2/custom-company-exhibition/custom-company-exhibition.vue";
import customCompanyRelease2 from "@components/custom-company-component-new/common2/custom-company-release/custom-company-release.vue";
import customCompanyActivity2 from "@components/custom-company-component-new/common2/custom-company-activity/custom-company-activity.vue";

export default {
  name: "custom-company-component-new",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      commmonArr: [
        {
          Banner: {
            type: 1, //类型Id
            isOpen: true, //是否开启
            coverType: "0", // 视频封面类型 0 截取 1 自定义
            cover: "http://wwww.huizhanren.com/1.jpg", // 封面
            time: 2000, // 视频封面截取帧
            path: "http://wwww.huizhanren.com/1.mp4", // 视频地址
            list: [
              {
                path: "http://wwww.huizhanren.com/1.jpg", //图片路径
                link: "http://www.baidu.com" //链接地址
              },
              {
                path: "http://wwww.huizhanren.com/2.jpg",
                link: "http://www.google.com"
              }
            ]
          },
          Objective: {
            type: 2,
            isOpen: true,
            title: "寻求代理",
            content: [
              {
                typeId: 1,
                key: "授权渠道",
                value: ["渠道1", "渠道2", "渠道3"],
                unit: "数量单位"
              },
              {
                typeId: 2,
                key: "招募地区",
                value: ["北京", "上海", "广州"],
                unit: "数量单位"
              },
              {
                typeId: 9,
                key: "员工人数",
                value: "50+",
                unit: "人"
              }
            ]
          },
          Activity: {
            type: 9,
            isOpen: true,
            title: "活动"
          },
          Release: {
            type: 3,
            isOpen: true
          },
          Cooperation: {
            type: 4,
            isOpen: true,
            title: "合作伙伴"
          },
          Brand: {
            type: 5,
            isOpen: true,
            title: "旗下品牌"
          },
          Example: {
            type: 6,
            isOpen: true,
            title: "成功案例"
          },
          ProductGroup: {
            type: 7,
            isOpen: true,
            groupId: ""
          },
        }
      ],
      selectArr: []
    };
  },
  components: {
    customCompanyRelease,
    customCompanyCooperation,
    customCompanyBrand,
    customCompanyExample,
    customCompanyProductGroup,
    customCompanyBanner,
    customCompanyHeader,
    customCompanyObjective,
    customCompanyExhibition,
    customCompanyActivity,

    customCompanyRelease2,
    customCompanyCooperation2,
    customCompanyBrand2,
    customCompanyExample2,
    customCompanyProductGroup2,
    customCompanyBanner2,
    customCompanyHeader2,
    customCompanyObjective2,
    customCompanyExhibition2,
    customCompanyActivity2,
  },
  created () {
    this.setActiveIndex(0);
    this.setActiveIndex2(0);
    if (this.defaultArr && this.defaultArr.length) {
      this.selectArr.push(...this.defaultArr);
    }
  },
  methods: {
    ...mapMutations({
      setDestroy: "customCompanyModule/setDestroy",
      setSave: "customCompanyModule/setSave",
      setLoad: "customCompanyModule/setLoad",
      setActiveIndex: "customCompanyModule/setActiveIndex",
      setActiveIndex2: "customComponentModule/setActiveIndex"
    }),
    closeModel (i, e) {
      this.selectArr.forEach((c, idx) => {
        let name = c.componentName + i;
        if (idx !== i) {
          if (this.$refs[name]) {
            this.$refs[name][0].hide(false);
          }
        }
      });
    },
    async saveCustom () {
      this.setSave(true); // 点击保存 子组件监听这个参数 传递改变的Modal数据
      setTimeout(() => {
        this.setSave(false);
      }, 400);
    },
    async reLoad () {
      this.setLoad(true); // 点击保存 子组件监听这个参数 传递改变的Modal数据
      setTimeout(() => {
        this.setLoad(false);
      }, 400);
    },
    send (i, e) {
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      copyData.map(c => {
        if (c.config.type === e.type) {
          c.config = e;
        }
      });
      this.$emit("sendModal", copyData);
    }
  },
  destroyed () { }
};
</script>

<style scoped lang="scss">
.custom {
  width: 968px;
  margin: 40px auto;
  display: flex;
  justify-content: space-between;
  &-tool2 {
    position: relative;
    margin-top: 40px;
  }
  &-tool {
    width: 375px;
    position: relative;
    &-title {
      font-size: 16px;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
      color: #333;
    }
    .ct {
      &-box {
        min-height: 230px;
        background: #f5f5f5;
        padding-bottom: 10px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
      }
      &-components {
        .ctc {
          &-title {
            padding: 10px 20px;
            font-size: 14px;
            color: #333;
          }
          &-group {
            padding: 0 20px 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          &-item {
            width: 95px;
            height: 60px;
            margin-bottom: 10px;
            background-color: #ebebeb;
            text-align: center;
            padding-top: 5px;
            cursor: pointer;
            .iconfont {
              font-size: 20px;
              color: #222;
            }
            &-txt {
              width: 100%;
              font-size: 12px;
              color: #222;
              // line-height: initial;
              line-height: 1;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped >
.ctb-item2 {
  width: 540px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
